const data = [
  {
    id: 1,
    voto: 3.5,
    recensione:
      "I'm baby cray activated charcoal swag af mustache chia put a bird on it four dollar toast woke ugh vaporware single-origin coffee listicle",
    autore: "Dejan Kulusewski",
  },
  {
    id: 2,
    voto: 5,
    recensione:
      "Ennui fixie cred, freegan knausgaard hashtag quinoa artisan subway tile street art shabby chic brooklyn.",
    autore: "Dominic Thiem",
  },
  {
    id: 3,
    voto: 1.5,
    recensione:
      "Prism asymmetrical squid four dollar toast kombucha blue bottle, hoodie DIY vape mustache.",
    autore: "Dimitrij Ovtcharov",
  },
  {
    id: 4,
    voto: 4,
    recensione:
      " PBR&B enamel pin kale chips heirloom meggings actually pok pok beard",
    autore: "Antonio Cairoli",
  },
];

export default data;
